import matchList, { MatchList, Pagination } from '@gin-betting/match-list';

import * as components from './components';
import * as epics from './epics';
import { getTopMarketComponentsBySport } from './getTopMarkets';
import messages from './messages';
import middleware from './middleware';
import reducer, { paginationReducer } from './reducer';
import * as selectors from './selectors';

export { MatchList, Pagination };
export default {
    components,
    ...matchList,
    selectors: { ...matchList.selectors, ...selectors },
    epics,
    reducer,
    paginationReducer,
    getTopMarketComponentsBySport,
    messages,
    middleware,
};
